import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { DataItemWithOverridesRefs } from '../../types'
import { BaseDataItem, StateDataItem } from '@wix/thunderbolt-becky-types'
import { getOverrideItem } from '../../dataConsumption'

const getResolvedOverrideItemNestingLevel = (items: Readonly<Array<BaseDataItem | undefined>>) =>
	items.findIndex(Boolean)!

export const States = createConsumptionDataNode<null, null, DataItemWithOverridesRefs>({
	toViewItem: ({ id, value: { dataItemWithOverrides } }) => {
		const dataItem = getOverrideItem(dataItemWithOverrides)
		if (!dataItem) {
			return
		}
		const overrideIndex = getResolvedOverrideItemNestingLevel(dataItemWithOverrides)

		if (overrideIndex === 0) {
			return dataItem
		}

		const ancestorsChain = getMultipleRefCompsIdFromInflatedId(id)
		const values = (dataItem as StateDataItem).values.map(
			(variantId: string) => `#${getUniqueId(ancestorsChain, removeHash(variantId))}`
		)
		return {
			...dataItem,
			values,
			id,
		}
	},
})
